import { createSlice } from "@reduxjs/toolkit";

interface State {
    editionId: number | null,
}
interface Action {
    type: string,
    payload: State
}

const editionSlice = createSlice({
    name: "editionSlice",
    initialState: {
        editionId: null
    },
    reducers: {
        setEdition(state: State, action: Action) {
            state.editionId = action.payload.editionId;
        },
          // ✅ Clear edition
        clearEdition(state: State) {
            state.editionId = null;
        }
    }
});

export const { setEdition, clearEdition} = editionSlice.actions;
export default editionSlice.reducer;